export default [
    {
        path: "*",
        meta: {
            public: true
        },
        redirect: {
            path: "/404"
        }
    },
    {
        path: "/404",
        meta: {
            public: true
        },
        name: "NotFound",
        component: () => import(`@/views/error/NotFound.vue`)
    },
    {
        path: "/403",
        meta: {public: true},
        name: "AccessDenied",
        component: () => import(`@/views/error/Deny.vue`)
    },
    {
        path: "/500",
        meta: {public: true},
        name: "ServerError",
        component: () => import(`@/views/error/Error.vue`)
    },
    {
        path: "/login",
        meta: {public: true},
        name: "Login",
        component: () => import(`@/views/Login.vue`)
    },
    {
        path: "/",
        meta: {},
        name: "Root",
        redirect: {
            name: "Home"
        }
    },
    {
        path: "/home",
        meta: {breadcrumb: true},
        name: "Home",
        component: () => import(`@/views/Home.vue`)
    },
    {
        path: "/permission",
        meta: {breadcrumb: true},
        name: "permission",
        component: () =>
            import(
                `@/views/Permission.vue`)
    },
    {
        path: "/roles",
        meta: {breadcrumb: true},
        name: "roles",
        component: () =>
            import(
                `@/views/Roles.vue`)
    },
    {
        path: "/users",
        meta: {breadcrumb: true},
        name: "users",
        component: () =>
            import(
                `@/views/Users.vue`)
    },
    {
        path: "/payment-methods",
        meta: {breadcrumb: true},
        name: "payment-methods",
        component: () =>
            import(
                `@/views/PaymentMethods.vue`)
    },
    {
        path: "/ios-version",
        meta: {breadcrumb: true},
        name: "ios-version",
        component: () =>
            import(
                `@/views/VersionIos.vue`)
    },
    {
        path: "/android-version",
        meta: {breadcrumb: true},
        name: "android-version",
        component: () =>
            import(
                `@/views/VersionAndroid.vue`)
    },
    {
        path: "/web-version",
        meta: {breadcrumb: true},
        name: "web-version",
        component: () =>
            import(
                `@/views/VersionWeb.vue`)
    },
];
